import React from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Typography,
  Button
} from "@material-tailwind/react";
import { ArrowLongRightIcon, ShieldCheckIcon, MagnifyingGlassCircleIcon, LightBulbIcon, ExclamationTriangleIcon, ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";


import { Link } from "react-router-dom";

export default function Cibercontent() {



  return (
    <>
     
      <div className="w-full mx-auto inline-block md:w-3/4 md:flex-row ">
        <Typography
          variant="h3"
          className="w-11/12 mx-auto mt-5 md:mt-0 lg:w-full mb-3 text-black font-sanz text-left"
        >
          Nuestros servicios de ciberseguridad
        </Typography>
        <Typography
          className="w-11/12 mx-auto md:mt-0 text-left lg:w-full font-mono text-xl"
        >
          La seguridad digital hoy es un requisito estratégico, especialmente en un Chile más regulado, conectado y en constante transformación. En Voxcom trabajamos junto a Cyberpeace, un ecosistema internacional especializado en prevención, inteligencia, monitoreo 24/7 y respuesta ante incidentes, para proteger tus datos, asegurar la continuidad de tus operaciones y reducir el impacto de amenazas emergentes.<br/><br/>
          
          Unimos la experiencia técnica de Cyberpeace con nuestra presencia local y conocimiento operativo en telecomunicaciones, industria, retail, agro, energía y servicios críticos. Esta alianza nos permite ayudarte a cumplir con las normativas vigentes, incluyendo la Ley Marco de Ciberseguridad 21.663 y la Ley 21.719 de Protección de Datos Personales, garantizando tu cumplimiento normativo y manteniendo tus procesos seguros en cada etapa.
        </Typography>
        <div className="flex flex-wrap justify-center gap-3 mt-10 md:justify-around">
          <Card className="mt-6 w-96">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                <ShieldCheckIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" />
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Prevención — CRA
                </Typography>
                <Typography className="group-hover:text-white">
                  Identificamos vulnerabilidades reales en tu infraestructura mediante servicios ofensivos como pruebas de penetración, análisis detallado de aplicaciones y ejercicios especializados de Red Team y Purple Team. Te entregamos un diagnóstico claro de tus riesgos junto con recomendaciones prácticas para prevenir brechas antes de que ocurran.
                </Typography>
              </CardBody>
              <CardFooter className="pt-0">
                <Link to="/Servicios-Ciberseguridad/prevencion-cra" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","AAC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conocer más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter>
            </div>
          </Card>
          <Card className="mt-6 w-96">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                <MagnifyingGlassCircleIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" />
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Detección — SOC / MDR
                </Typography>
                <Typography className="group-hover:text-white">
                  El servicio SOC360 supervisa tu entorno digital de manera continua, identificando actividades sospechosas con precisión y profundidad. Combina monitoreo 24/7/365, correlación avanzada de eventos, análisis de amenazas, threat hunting y respuestas automatizadas mediante SOAR para reaccionar a tiempo y proteger tus operaciones de manera eficaz.
                </Typography>
              </CardBody>
              <CardFooter className="pt-0">
                <Link to="/Servicios-Ciberseguridad/deteccion-soc" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","DPC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conocer más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter>
            </div>
          </Card>
          <Card className="mt-6 w-96">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                <LightBulbIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" />
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Inteligencia — CTI
                </Typography>
                <Typography className="group-hover:text-white">
                  Anticipamos riesgos antes de que impacten tus plataformas, generando inteligencia accionable para tu organización y sus directivos. Monitoreamos superficies de ataque —incluyendo dark web y deep web— y analizamos indicadores de amenazas mediante honeynets. Obtienes alertas tempranas y contexto clave para tomar decisiones preventivas.
                </Typography>
              </CardBody>
              <CardFooter className="pt-0">
                <Link to="/Servicios-Ciberseguridad/inteligencia-cti" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","ETC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conocer más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter>
            </div>
          </Card>
          <Card className="mt-6 w-96">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                <ExclamationTriangleIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" />
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Respuesta — CP-CSIRT
                </Typography>
                <Typography className="group-hover:text-white">
                  Activamos equipos especializados cuando ocurre un incidente real, reaccionando rápidamente para contener el impacto. El CSIRT coordina la contención, realiza análisis forense detallado y guía todo el proceso de recuperación operativa. Además, cada evento se transforma en aprendizajes que fortalecen tu protección futura y elevan tu madurez de seguridad.
                </Typography>
              </CardBody>
              <CardFooter className="pt-0">
                <Link to="/Servicios-Ciberseguridad/respuesta-csirt" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","DPC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conocer más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter>
            </div>
          </Card>
          <Card className="mt-6 w-96">
            <div className=" group rounded-lg p-1 hover:bg-indigo-500 transition duration-300 ">
              <CardBody>
                <ClipboardDocumentCheckIcon className="text-indigo-500 w-12 h-12 mb-4 group-hover:text-white" />
                <Typography variant="h5" color="blue-gray" className="mb-2 group-hover:text-white">
                  Cumplimiento — ISG
                </Typography>
                <Typography className="group-hover:text-white">
                  Te ayudamos a implementar una gobernanza de seguridad sólida y alineada con los objetivos de tu negocio. Gestionamos riesgos, diseñamos políticas clave y operamos marcos internacionales como ISO 27001 o un SGSI. Fortalecemos la confidencialidad, integridad y disponibilidad de tu información, asegurando un cumplimiento continuo y sostenible.
                </Typography>
              </CardBody>
              <CardFooter className="pt-0">
                <Link to="/Servicios-Ciberseguridad/cumplimiento-isg" className="inline-block">
                  <Button onClick= {() => {localStorage.setItem("ESP","CIB"); localStorage.setItem("SER","DPC")}} size="sm" variant="text" className="flex items-center gap-2 text-indigo-500 group-hover:text-white">
                    Conocer más sobre este servicio
                    <ArrowLongRightIcon strokeWidth={2} className="w-4 h-4 group-hover:text-white" />
                  </Button>
                </Link>
              </CardFooter>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}